let currentPage = 1;
let loading = false;
let hasMore = true;

function loadMoreProducts() {
  if (loading || !hasMore) return;

  loading = true;
  currentPage++;
  document.getElementById("loading-spinner").style.display = "block";

  const nextPageUrl = `${window.location.pathname}?page=${currentPage}`;

  fetch(nextPageUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts = doc.querySelectorAll('[data-product-grid-item]');
      const productGrid = document.querySelector('[data-product-grid]');

      if (newProducts.length === 0) {
        hasMore = false;
      } else {
        newProducts.forEach(item => productGrid.appendChild(item));
      }

      loading = false;
      document.getElementById("loading-spinner").style.display = "none";
    })
    .catch(err => {
      console.error('Infinite Scroll error:', err);
      loading = false;
    });
}

function handleScroll() {
  const trigger = document.getElementById("infinite-scroll-trigger");
  if (!trigger) return;

  const triggerOffset = trigger.getBoundingClientRect().top;
  const windowHeight = window.innerHeight;

  if (triggerOffset - windowHeight < 100) {
    loadMoreProducts();
  }
}

window.addEventListener('scroll', handleScroll);
